import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import "../../css/ListScores.css";

import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
require("highcharts/modules/accessibility")(Highcharts);

const DisplayProductionBarChart = ({ key, chartOptions }) => {
	const { t } = useTranslation();
	useEffect(() => {
		Highcharts.setOptions({
			colors: [ '#058DC7',  '#DB7093', '#b3d4ff', '#b366ff', '#F5DEB3', '#1a53ff', '#00bfa0', '#dc0ab4', 
			 '#7c1158', '#4421af', '#5d6d7e', '#FFC0CB', '#4d0000','#24CBE5',  '#e9c3ef','#80dfff',
			'#0bb4ff',  '#9b19f5', '#9e6f00',   '#2bc2c2', '#ff6696',
		    '#96a527', '#024b7a',  '#b2b0ea']
		});
	}, []);

	return (
		<div key={key}>
			<div className="row">
				<div className="col">
					<h5 style={{ marginLeft: "2vw", textAlign: 'center',marginBottom: "50px" }}><b><span style={{ marginRight: "30px" }}></span>{t("page.prod.trend")}</b></h5>
				</div>
			</div>
			
			
			<div className="row" id="reportContainer" >
				<div className="col">
					<HighchartsReact key="0" highcharts={Highcharts} containerProps={{ style: { height: "40vh", minHeight: "10vh", maxHeight: "50vh", overfow: "visible" } }}
						options={chartOptions}
					/>
				</div>
			</div>
			<div className="row" style={{ marginTop: "5vh" }}>
				<div className="col">
					<div className="placeholder-pg"></div>
				</div>
			</div>
		</div>
	)
}

export default DisplayProductionBarChart;